<template>
<div style="margin:5px;">
      <br>
          <Row><Col span="12" offset="10"><div class="myTitle" >低价游列表</div></Col></Row>
        <br>
        <Row>
                <div class="queryForm">
                    <Form ref="queryFormRef" :model="queryForm" :label-width="80" inline>
                         <FormItem label="标题" prop="keyword" >
                            <Input v-model="queryForm.keyword" placeholder="标题" style="width:250px"></Input>
                        </FormItem>
                       
                  <FormItem label="开始时间" prop="startTime" >
                    <DatePicker type="date" placeholder="请选择开始时间" format="yyyy-MM-dd"
                    v-model="queryForm.startTime"  @on-change="queryForm.startTime=$event"
                    ></DatePicker>
                </FormItem>
       
                  <FormItem label="结束时间" prop="endTime" >
                    <DatePicker type="date" placeholder="请选择结束时间" format="yyyy-MM-dd"
                    v-model="queryForm.endTime"  @on-change="queryForm.endTime=$event"
                    ></DatePicker>
                </FormItem>
           
                        <Button type="info"  @click="queryBtn" >查询</Button>
	                    <Button type="success"  @click="resetQueryForm">重置</Button>
                    </form>
                </div>
            </Row>
            
        
             <br>
      <Row >
          <Col span="20" offset="1">
            <div style="float:left">
               <Button type="info"  @click="openAddForm()">新增</Button>&nbsp;&nbsp;&nbsp;
               <Button type="success"   @click="openExport()">导出</Button>&nbsp;&nbsp;&nbsp;
               <Upload   
                  :action="uploadUrl"
                  name="file" 
                  :on-success="handleSuccess" 
                  :before-upload="handleBeforeUpload"
                   :headers = "headers"
                  multiple = "multiple"
                  :show-upload-list="showUploadList"
             >
                    <Button type="success" >导入</Button>
                </Upload>&nbsp;
               <a href="https://patrol.stwhgl.com/stat_report/低价参考数据批量导入-参考模板.xlsx" target="_blank">导入模板下载</a>
               
            </div>
          </Col>
      </Row>
      <br>
      <Row>
          <Col span="24">
              <Table :loading="loading" @on-selection-change="selectRow" 
                border ref="table" stripe :columns="columns4" :data="listData">
                <template slot-scope="{ row }" slot="name">
                  <strong>{{ row.name }}</strong>
                </template>
                <template slot-scope="{ row }" slot="action">
               
                  <Button type="info" size="small" @click="openUpdateForm(row)">修改</Button>
                 <Button type="error" size="small" @click="deleleRows(row)">删除</Button>
                </template>
              </Table>
          </Col>
      </Row>
      <Row>
        <Col span="24">
          <div>
            <Footer>
              <Page show-sizer show-total :total="rowCount" :current="current"
                :page-size="pageSize"  @on-change="changePage"
                @on-page-size-change="changeSize" />
            </Footer>
          </div>
        </Col>
    </Row>
  <MinPrinceEdit ref="minPrinceEdit"></MinPrinceEdit>
  <MinPrinceAdd ref="minPrinceAdd"></MinPrinceAdd>
 
</div>
</template>

<script>

  import MinPrinceEdit from '@/pages/platform/minprince/MinPrinceEdit';
  import MinPrinceAdd from '@/pages/platform/minprince/MinPrinceAdd';
  import  downloadTemplate   from "@/utils/downloadFile";
   import {getCookie} from '@/utils/cookieUtils'


  export default {
    components: {
        MinPrinceEdit,
        MinPrinceAdd,
    },
    methods: {
    
      selectRow(selection) {
        this.selectRows = selection;
      },
      //打开新增对话框
      openAddForm() {
        this.$refs.minPrinceAdd.openModal('新增',null);
      },
      //打开修改对话框
      openUpdateForm(row) {
       this.$refs.minPrinceEdit.openModal('修改',row);
       
      },
      handleBeforeUpload(){
          return true;
      },
      //上传文件成功
       handleSuccess(res, file) {
          this.$Message.success(
                                {
                                    content:res.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
      },
      //导出
      openExport(){
            let url = `/api/reference_data/export_data`
                      this.req({
                         url: url,
                          method: 'post',
				                	responseType: "arraybuffer",
                          data: {
                                 keyword:this.queryForm.keyword,
                                 startTime:this.queryForm.startTime,
                                 endTime : this.queryForm.endTime
                          }
                      }).then(response => {
                          downloadTemplate.fileDownload(response.data, "minprice.xlsx");
                     }).catch(error => {
                          this.$Message.error('服务器错误:' + error)
                     })
      },
    
       //执行删除操作
            deleleRows(row) {
               
                this.$Modal.confirm({
                    title: '删除',
                      content: `确认要删除\"${row.title}\"吗?`,
                    onOk: () => {
                         this.loading = true
                         let url = `/api/reference_data/del_data`
                            this.req({
                                url: url,
                                method: 'post',
                                data: {
                                    _id: row._id
                                }
                            }).then(response => {
                                this.$Message.success(
                                {
                                    content:response.data.msg,
                                    top: 80,
                                    onClose: ()=>{
                                        this.loading = false
                                        this.loadPage();
                                    }
                                }
                                )
                        }).catch(error => {
                                this.$Message.error('服务器错误:' + error)
                        })
                    },
                    onCancel: () => {
                       // this.loading = false
                    }
                });

            },
      
      loadPage() {
         this.loading = false
        let url   = `api/reference_data/get_low_price_list`
        this.req({
          url: url,
          method: 'post',
          data:{
            p: this.current,
            pageSize: this.pageSize,
            keyword:this.queryForm.keyword,            
            startTime:this.queryForm.startTime,
            endTime : this.queryForm.endTime
          }
        }).then(resp => {
          this.buildPageData(resp.data.page)
          this.loading = false
        }).catch(error => {
          this.$Message.error('服务器错误2:' + error);
        })
      },
      changePage(curPage) {
        this.loading = true
        this.current = curPage
        this.loadPage()
      },

      changeSize(pageSize) {
        this.pageSize = pageSize
        this.loading = true
        this.loadPage()
      },
      buildPageData(dataObj) {
        this.listData = dataObj.list;
        this.pageSize = dataObj.size;
        this.rowCount = dataObj.rowCount;
        this.currentPage = dataObj.p;
      },
      resetQueryForm() {
        this.$refs["queryFormRef"].fields.forEach(function (e) {
           e.resetField()
        })
      },
      queryBtn(){
                this.current = 1
                this.loadPage()
      },
   
     
     
    },
    mounted: function () {
      this.loadPage();
       this.loading = false
       this.uploadUrl =  window.g.ApiUrl + "api/reference_data/add_many_data"
    },
    data() {
      return {
        listData: [],
        pageSize: 10,
        current: 1,
        rowCount: 0,
        loading: true,
        deleteId: '',
        showcity: true,
        showcountry: true,
        uploadUrl:'',        
        showUploadList: false,
        headers: {
            token: getCookie('wcToken') 
        },
        columns4: [{
            type: 'index',
            title:'序号',
            width: 80,
            align: 'center',
          },
          
           {
            title: '来源',
            align: 'center',
            width: 160,
            key: 'source'
          },
          {
            title: '标题',
            align: 'center',
            key: 'title',
          },
          
          {
            title: '类别',
            align: 'center',
            width: 160,
            key: 'title_type'
          },
         {
            title: '价格',
            align: 'center',
            width: 160,
            key: 'price'
          },{
            title: '添加时间',
            align: 'center',
            width: 160,
            key: 'createTime'
          },
          {
            title: '操作',
            slot: 'action',
            width: 180,
            align: 'center'
          }
        ],
       //查询表单的初始值
          queryForm: {
              keyword: '',
              startTime: '',
              endTime: '',
          }
      }
    },

  }
</script>

<style scoped>
  .ivu-layout-header {
    background: #f5f7f9;
  }

 

  .queryForm {
    padding: 10px;
  }
  .queryBtn {
    padding-bottom: 5px;
    padding-left: 700px;
    border-bottom: rgb(160, 146, 146) solid 1px;
  }
  .optBtn {
    margin: 10px;
  }
  .ivu-form-item {
    margin-bottom: 0px;
  }
  .a {
    color: #fff;
  }
   .myTitle{
      font-size: 20px;
      font-weight: 700;
  }
  .ivu-upload{
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/minprince/MinPrinceList.vue